var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button, Form, Header, Modal as UIModal } from 'semantic-ui-react';
import * as ReportApi from '~/Api/Report';
import { useApi } from '~/ApiHooks';
import { ReportsRoute } from '~/Application/routes';
import { useStore } from '~/Application/Store';
import { MessageType, useFlashMessage } from '~/FlashMessage';
var defaultNewReport = {
    description: '',
    historized: false,
    name: '',
};
export var SaveReportModal = function (_a) {
    var report = _a.report, onClose = _a.onClose;
    var reloadCustomReports = useStore().reloadCustomReports;
    var _b = useFlashMessage(), setFlashMessage = _b[1];
    var _c = React.useState(defaultNewReport), newReport = _c[0], setNewReport = _c[1];
    var _d = useApi(), saveReport = _d[0], result = _d[1];
    var redirect = ReportsRoute.useRedirect();
    var reportSettings = {
        columnFilters: report.columnFilters,
        hiddenColumns: report.hiddenColumns.map(function (column) { return column.id; }),
        sort: report.sort,
    };
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        description: newReport.description.trim(),
                        historized: newReport.historized,
                        name: newReport.name.trim(),
                        reportId: report.id,
                        reportSettings: reportSettings,
                    };
                    return [4 /*yield*/, saveReport(new ReportApi.CreateRequest(data))];
                case 1:
                    result = _a.sent();
                    if (result.value !== null) {
                        setFlashMessage({ text: 'Uloženo', type: MessageType.success });
                        reloadCustomReports();
                        redirect({});
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (<UIModal open size='tiny' onClose={onClose}>
			<UIModal.Content>
				<Header>Uložit</Header>
			</UIModal.Content>
			<UIModal.Content>
				<Form>
					<Form.Input fluid inline data-testid='report-name-input' placeholder='Název reportu' vlaue={newReport.name} onChange={function (event) {
            setNewReport(__assign(__assign({}, newReport), { name: event.target.value }));
        }}/>
					<Form.Input fluid inline data-testid='report-description-input' placeholder='Popis reportu' vlaue={newReport.description} onChange={function (event) {
            setNewReport(__assign(__assign({}, newReport), { description: event.target.value }));
        }}/>
					<Form.Input inline label='Historizovat data reportu?' type='checkbox' onChange={function () {
            setNewReport(__assign(__assign({}, newReport), { historized: !newReport.historized }));
        }}/>
				</Form>
			</UIModal.Content>
			<UIModal.Actions>
				<Form.Button data-testId='save-report-modal-confirm' disabled={newReport.name.trim() === '' || newReport.description.trim() === '' || result.isLoading} floated='right' onClick={save}>
					Uložit
				</Form.Button>
				<Button disabled={result.isLoading} onClick={onClose}>
					Zrušit
				</Button>
			</UIModal.Actions>
		</UIModal>);
};
